export const fonts = {
  primary: `'Open Sans', sans-serif`,
  secondary: `sans-serif`,
  headings: `'Parkinsans', 'Open Sans', sans-serif`,
};
